import styled from 'styled-components';

export const WelcomeModalContainer = styled.div`
  text-align: center;

  img {
    width: 120px;
    margin: 0 auto;
    display: block;
    text-indent: -10000px;
  }

  p {
    font-size: 14px;
  }
  
  a {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.primary};
  }
  
  h2 {
    text-transform: uppercase;
    font-weight: bold;
    margin-top: 24px;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const ModalActionsContainer = styled.div`
  text-align: right;
`;
